/**
 * @module Cohesion Event Hooks
 * @description
 */
import { useEffect } from "react";
import { setCookie } from "@/js/utils/cookie";

/**
 * @function useCohesionEvents
 * @description
 */
export const useCohesionEvents = () => {
  useEffect(() => {
    cohesion("monarch:done", (err, evaluation) => {
      const trafficFlow = evaluation?.source?.trafficFlow || {};
      const { value: { experienceNumber, experienceName } = {}, audienceName } =
        trafficFlow;
      // Set session cookies for use in cart's Preamp audiences.
      // This allows for consistent experiences from MLP to cart.
      setCookie("expNumber", experienceNumber || "", 0, { otGroup: "C0002" });
      setCookie("expName", experienceName || "", 0, { otGroup: "C0002" });
      setCookie("audienceName", audienceName || "", 0, { otGroup: "C0002" });
    });
  }, []);
};
